<template>
  <div>
    <span>
      <Icon
        v-if="isHiddenInUserPortal"
        icon="viewableOff"
        :inline="true"
      />
      {{ isHiddenInUserPortal ? 'No' : 'Yes' }}
    </span>
  </div>
</template>

<script>
import { Icon } from '@jumpcloud/ui-components';

export default {
  name: 'ApplicationShownInUserPortal',

  components: {
    Icon,
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    isHiddenInUserPortal() {
      return this.item.sso.hidden;
    },
  },
};
</script>
